import React, { useEffect, useState } from 'react'
import InputOption from '../../component/InputOption/InputOption';
import axios from 'axios';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { getToken } from '../../../../helpers/Jwt';
import { useNavigate } from 'react-router-dom';

const EntryBudgetManagement = () => {

  const navigate = useNavigate();

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PATH_ACCOUNT = "api/erpppsu/account/cashbank";
  const PATH_BUDGET = "api/erpppsu/budget";

  const [data, setData] = useState([]);
  const [dataAccount, setDataAccount] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [nameBudget, setNameBudget] = useState("Anggaran");
  const [firstPeriod, setFirstPeriod] = useState("");
  const [totalPeriod, setTotalPeriod] = useState("");
  const [beforePeriod, setBeforePeriod] = useState("");

  const [tableData, setTableData] = useState([]);
  const [headers, setHeaders] = useState([]);

  const fetchData = async (URL) => {
    try {
      const response = await axios.get(URL);
      return response.data;
    } catch (err) {
      setError("Failed to fetch data. Please try again later.");
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const generateTable = () => {
    if (!firstPeriod || !totalPeriod) {
      alert("Awal Periode dan Jumlah Periode wajib ditetapkan");
      return;
    }

    if (dataAccount.length == 0) {
      alert("Belum ada akun yang disimpan");
      return;
    }

    const startDate = new Date(`${firstPeriod}-01`);
    const months = [];
    for (let i = 0; i < totalPeriod; i++) {
      const newDate = new Date(startDate);
      newDate.setMonth(startDate.getMonth() + i);
      months.push(newDate.toLocaleString("id-ID", { month: "long", year: "numeric" }));
    }

    const closeDate = new Date(`${firstPeriod}-01`);
    const monthsBefore = [];
    for (let i = beforePeriod; i > 0; i--) {
      const newDate = new Date(closeDate);
      newDate.setMonth(closeDate.getMonth() - i);
      monthsBefore.push(newDate.toLocaleString("id-ID", { month: "long", year: "numeric" }));
    }

    setHeaders(["Akun", ...monthsBefore, ...months, "Total"]);

    const data = dataAccount?.map(account => ({
      id_account: account.id,
      name_account: account.name,
      type_account: account.type,
      values: [...Array(monthsBefore.length).fill(0), ...Array(months.length).fill(0)],
      total: 0,
    })) || [];

    setTableData(data);
  };

  const handleInputChange = (rowIndex, periodIndex, value) => {
    const updatedTableData = [...tableData];
    const row = updatedTableData[rowIndex];
    row.values[periodIndex] = parseFloat(value) || 0;
    row.total = row.values.reduce((sum, val) => sum + val, row.previous || 0);
    setTableData(updatedTableData);
  };

  useEffect(() => {
    fetchData(`${BASE_URL}${PATH_ACCOUNT}?types=income,cost_of_goods_sold,expenses`).then((data) => {
      setDataAccount(data)
    });
  }, []);

  // Pendapatan
  // Beban Pokok Pendapatan
  // Beban Operasional
  // Pendapatan (beban lain-lain)
  // Laba (Rugi)

  const initialValues = {
  };

  const validationSchema = Yup.object({
    // description: Yup.string().required('Deskripsi diperlukan'),
    // amount: Yup.number().required('Jumlah diperlukan').positive('Jumlah harus lebih besar dari nol'),
  });

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const payload = {
        'name': nameBudget,
        'first_period': firstPeriod,
        'total_period': totalPeriod,
        'total_period_before': beforePeriod,     
        'values' : values
      };

      console.log(payload);
      

      await axios.post(`${BASE_URL}${PATH_BUDGET}`, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${  getToken() }`
        }
      });

      navigate('/activity-erpppsu/budget-management');
    } catch (error) {
      alert(error.response.data);
      console.error('Error submitting form:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="p-4">
      <h1 className="text-lg font-bold mb-4">Manajemen Anggaran</h1>

      <div className="container m-auto grid grid-cols-5 sm:grid-cols-2 xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-5 my-3 gap-4">
        <div className="">
          <label htmlFor="name" className="block mb-1 text-sm font-semibold">
            Nama Anggaran
          </label>
          <input
            id="name"
            name="name"
            type="text"
            className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
            defaultValue={nameBudget}
            onChange={(e) => setNameBudget(e.target.value)} />
        </div>
      </div>
      <div className="container m-auto grid grid-cols-5 sm:grid-cols-2 xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-5 my-3 gap-4">
        <div className="">
          <label htmlFor="first_period" className="block mb-1 text-sm font-semibold">Awal Periode</label>
          <input
            id="first_period"
            name="first_period"
            type="month"
            className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
            defaultValue={firstPeriod}
            onChange={(e) => setFirstPeriod(e.target.value)} />
        </div>

        <div className="">
          <label htmlFor="first_period" className="block mb-1 text-sm font-semibold">Jumlah Periode</label>
          <InputOption
            label="Pilih Jumlah Periode"
            data={[
              {
                'id': 1,
                'code': '',
                'name': '1 Periode',
              },
              {
                'id': 2,
                'code': '',
                'name': '2 Periode',
              },
              {
                'id': 3,
                'code': '',
                'name': '3 Periode',
              },
              {
                'id': 4,
                'code': '',
                'name': '4 Periode',
              },
              {
                'id': 6,
                'code': '',
                'name': '6 Periode',
              },
              {
                'id': 8,
                'code': '',
                'name': '8 Periode',
              },
              {
                'id': 12,
                'code': '',
                'name': '12 Periode',
              },
              {
                'id': 24,
                'code': '',
                'name': '24 Periode',
              }
            ]}
            placeholder="Ketik disini"
            onChange={(value) => setTotalPeriod(value)}
          />
        </div>

        <div className="">
          <label htmlFor="first_period" className="block mb-1 text-sm font-semibold">Periode Sebelumnya</label>
          <InputOption
            label="Pilih Periode Sebelumnya"
            data={[
              {
                'id': 3,
                'code': '',
                'name': '3 Periode Terakhir',
              },
              {
                'id': 6,
                'code': '',
                'name': '6 Periode Terakhir',
              },
              {
                'id': 12,
                'code': '',
                'name': '12 Periode Terakhir',
              }
            ]}
            placeholder="Ketik disini"
            onChange={(value) => setBeforePeriod(value)}
          />
        </div>

        {/* Filter Button */}
        <div className="p-3 flex items-end">
          <button
            onClick={generateTable}
            type="button"
            className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200"
          >
            Filter
          </button>
        </div>
      </div>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, handleChange, setFieldValue, isSubmitting }) => (
          <Form>
            {tableData.length > 0 && (
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr>
                    {headers.map((header, index) => (
                      <th
                        key={index}
                        className="border border-gray-300 px-4 py-2 text-left bg-gray-100"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td className="border border-gray-300 px-4 py-2">
                        {row.name_account}&nbsp;<span className='font-bold align-top text-xs'>{row.type_account}</span>
                      </td>
                      {row.values.map((value, periodIndex) => (
                        <td className="border border-gray-300 px-4 py-2" key={periodIndex}>
                          <input
                            name={`${row.id_account}_${periodIndex}`}
                            type="number"
                            className="border rounded-md p-1 w-full"
                            value={value || ""}
                            onChange={(e) => {
                              setFieldValue(`${row.id_account}_${periodIndex}`, e.target.value);
                              handleInputChange(rowIndex, periodIndex, e.target.value)
                            }}
                          />
                        </td>
                      ))}
                      <td className="border border-gray-300 px-4 py-2">{row.total}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            <div className="flex items-center justify-end mt-5">
              <button
                type="submit"
                disabled={isSubmitting}
                className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
              >
                {isSubmitting ? 'Menyimpan...' : 'Simpan'}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default EntryBudgetManagement;